import React from 'react';

const FlavorText = (props) => {
  const { text } = props;

  return (
    <div style={{ margin: '2rem 0' }}>
      <p
        style={{
          fontFamily: '"Roboto", "sans-serif"',
          fontWeight: 'normal',
          fontSize: '16px',
          color: '#000',
          textAlign: 'center',
        }}
      >
        <em>{text}</em>
      </p>
    </div>
  );
};

export default FlavorText;
